var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container content-comunicacao" }, [
    _c("div", { staticClass: "content-conversas full-width" }, [
      _c("div", { staticClass: "comunicacao-main" }, [
        _c(
          "div",
          { staticClass: "busca-comunicacao" },
          [
            _c("search-conversas", {
              attrs: { botaoLimpar: true },
              on: { search: _vm.search, limpar: _vm.handleLimpar }
            })
          ],
          1
        )
      ])
    ]),
    _c("div", { staticClass: "content-conversas full-width" }, [
      _c(
        "div",
        { staticClass: "comunicacao-main" },
        [
          _c(
            "div",
            { staticClass: "listagem-conversas" },
            [_c("listagem-conversas", { attrs: { conversas: _vm.conversas } })],
            1
          ),
          _c("app-paginacao", {
            attrs: {
              total: _vm.totalConversas,
              pagina: _vm.paginaFiltro.pagina + 1,
              tamanhoPagina: _vm.paginaFiltro.tamanhoPagina
            },
            on: { changePage: _vm.changePage }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b1d946e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b1d946e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/comunicacao/Comunicacao.vue
// module id = null
// module chunks = 